<template>
  <div class="vehicle-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="data.plate"><strong>{{ $t('involvedSummary.vehicle.plateLabel') }}</strong> {{ data.plate }}</span>
      <span v-if="vehicleTypeLabel"><strong>{{ $t('involvedSummary.vehicle.typeLabel') }}</strong> {{ vehicleTypeLabel }}</span>
      <span v-if="brandModel"><strong>{{ $t('involvedSummary.vehicle.vehicleLabel') }}</strong> {{ brandModel }}</span>
      <span v-if="data.color"><strong>{{ $t('involvedSummary.vehicle.colorLabel') }}</strong> {{ data.color }}</span>
      <span v-if="data.year"><strong>{{ $t('involvedSummary.vehicle.yearLabel') }}</strong> {{ data.year }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleSummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    brandModel() {
      return [this.data.brand, this.data.model].filter(Boolean).join(' ')
    },
    vehicleTypeLabel() {
      const map = {
        carro: this.$t('involvedSummary.vehicle.vehicleType.car'),
        moto: this.$t('involvedSummary.vehicle.vehicleType.motorcycle'),
        caminhao: this.$t('involvedSummary.vehicle.vehicleType.truck'),
        onibus: this.$t('involvedSummary.vehicle.vehicleType.bus'),
        outro: this.$t('involvedSummary.vehicle.vehicleType.other'),
      }
      return map[this.data.vehicle_type] || this.data.vehicle_type || ''
    },
  },
}
</script>
